/**
 * Settings Components
 * A layout component that manages the settings interface with sidebar navigation
 * Handles route management and default navigation for the settings section
 */

import SidebarMenu from "./sidebar-menu";
import { Outlet } from "react-router-dom";
import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

/**
 * Settings Component
 * Main settings layout component with sidebar navigation and content area
 *
 * Features:
 * - Automatic redirection to default settings page
 * - Persistent sidebar navigation
 * - Dynamic content rendering through Outlet
 * - Responsive layout structure
 *
 * The component handles default route management and provides
 * a consistent layout for all settings pages.
 *
 * @returns {JSX.Element} A two-column layout with navigation and content areas
 */
const Settings = () => {
  const navigate = useNavigate();
  const location = useLocation();

  /**
   * Effect hook to manage default navigation
   * Redirects to configurations page when accessing root settings path
   */
  useEffect(() => {
    const checkUrlAndRedirect = () => {
      const currentPath = location.pathname;
      if (currentPath === "/admin/settings") {
        navigate("/admin/settings/configurations");
      }
    };

    checkUrlAndRedirect();
  }, [navigate, location]);

  return (
    <div className="min-h-screen flex">
      <SidebarMenu isOpen={true} toggleSidebar={true} />
      <div className="flex-1 py-1 px-4">
        <Outlet />
      </div>
    </div>
  );
};

export default Settings;
